import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export const SECTION_ORDER = ['products', 'interiors', 'project-room', 'collaborations', 'about'] as const;

const sectionLabels: Record<string, () => [string, ...any[]]> = {
  products: () => __(translations.webHomepage.sectionEshop, 'Products'),
  interiors: () => __(translations.webHomepage.sectionInteriors, 'Interiors'),
  'project-room': () => __(translations.webHomepage.sectionProjectRoom, 'Project Room'),
  collaborations: () => __(translations.webHomepage.sectionCollaborations, 'Collaborations'),
  about: () => __(translations.webHomepage.sectionAbout, 'About'),
};

export const getSectionTitle = (slug: string): [string, ...any[]] =>
  sectionLabels[slug]?.() ?? __(translations.common.section, 'Section');

export default {
  title: () => __(translations.webHomepage.title, 'Web Homepage'),
  titleFr: () => __(translations.webHomepage.titleFr, 'Title (FR)'),
  titleEn: () => __(translations.webHomepage.titleEn, 'Title (EN)'),
};
